export default __webpack_public_path__ + "static/media/baunebakken.a60718e9.mp4";